<template>
  <esg-base-chart>
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart height="175"
                ref="chart"
                type="bar"
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      categories: [],
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
          toolbar: { show: false },
          zoom: { enabled: true },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '30%'
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
          labels: {
            show: false
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          x: {
            show: false
          },
          y: {
            formatter: (val) => this.formatNumber(val, 0) + " tCO2"
          }
        },
        grid: {
          show: false
        },
        legend: {
          show: true,
          position: 'bottom',
        },
      },
    }
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData()
      }
    },
    year: {
      handler() {
        this.fetchData()
      }
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return
      if (!this.year) return

      try {
        this.loading = true;

        // Chart meta data
        let chartMeta = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          groupKeys: ['material_input_id', 'material_input_name']
        }]

        // Construct form data for HTTP request
        let formData = new FormData()
        formData.append('path', 'esg/lca/material_detail/main')
        formData.append('json', JSON.stringify(chartMeta))

        // Request data for the chart
        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', formData, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, throw an error
        if (!response.data.data) {
          return
        }

        // Parse JSON data
        let chartData = JSON.parse(response.data.data)[0].data

        // Extract material names
        let materials = chartData.map(row => row.material_input_name)

        // Group data based on LCA process and product name
        let seriesMap = new Map()
        for (let material of materials) {
          let ghg = chartData
              .filter(row => row.material_input_name === material)
              .map(row => row.values)
              .pop() || 0
          if (seriesMap.has(material)) {
            const series = seriesMap.get(material)
            series.push(ghg)
          } else {
            seriesMap.set(material, [ghg])
          }
        }

        // Set series and x axis labels
        this.series = Array.from(seriesMap, ([name, data]) => ({ name, data }))
        this.categories = Array.from(seriesMap.keys())
      } catch (error) {
        this.loading = false;
        await this.showError(error)
      } finally {
        this.loading = false;
        this.refreshChart()
      }
    },
  }
}
</script>
